import { render } from "./IconMultiview.vue?vue&type=template&id=2656363f"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconMultiview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2656363f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2656363f', __exports__)) {
    api.reload('2656363f', __exports__)
  }
  
  module.hot.accept("./IconMultiview.vue?vue&type=template&id=2656363f", () => {
    api.rerender('2656363f', render)
  })

}


export default __exports__